// extracted by mini-css-extract-plugin
export default {"root":"styles_root__a1Eav","dataList":"styles_dataList__QVBBo"};